import { ReactElement } from 'react';
import { CartesianData } from '../ChartWidgetViewer';
import { ColumnChartWidgetConfiguration } from '@methodset/application-client-ts';
import { ApexChartUtils } from '../ApexChartsUtils';
import ReactApexChart from 'react-apexcharts';
import classNames from 'classnames';
import './ColumnChartView.less';

export type ColumnChartViewProps = {
    className?: string,
    data: CartesianData,
    configuration: ColumnChartWidgetConfiguration
};

export const ColumnChartView = (props: ColumnChartViewProps): ReactElement => {

    const series = (): ApexAxisChartSeries => {
        return props.data.seriesList;
    }

    const options = (): ApexCharts.ApexOptions => {
        const options = ApexChartUtils.cartesianOptions("bar", props.data, props.configuration);
        options.chart!.stacked = !!props.configuration.isStacked;
        options.plotOptions = {
            bar: {
                horizontal: false
            }
        }
        return options;
    }

    return (
        <div className={classNames('x-columnchartview', props.className)}>
            <ReactApexChart
                options={options()}
                series={series()}
                type="bar"
                height={props.configuration.height}
            />
        </div>
    )
}
